import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CancelarFactura } from "../../cancelacion";
import { ConceptoFacturaList } from "./conceptos/list";
import { AuxiliarReceptor } from "./auxiliarreceptor";
import { TipoPersonaModal } from "./tipopersonamodal";
import { validarReceptor } from "./receptorfactura";
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/toPromise";

type Entity = models.FacturaDto;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    soloLectura: boolean;
    desdeNota?: boolean;
    ocultarMensajeTimbrado?: boolean;
    permisos: models.Rol;
    nuevo: boolean;
    onGuardarSinSalir?: () => Promise<void>;
    onGuardarBanderasCobranza: () => Promise<void>;
    onRefresh: () => Promise<void>;
}

/**
* Valida un Factura
*/
export function validar(x: Entity) {
    const validarConceptos = (value: Entity) =>
        ((x.Conceptos == null || x.Conceptos.length == 0)) ? false : true;

    const rules: validation.Rules<Entity> = {
        FechaFactura: validation.required,
        FechaPolizaContable: validation.required,
        ReceptorFactura: validation.subrule(validarReceptor),
        IdCliente: validation.required,
        IdMetodoPagoSAT: validation.required,
        IdFormaPagoSAT: validation.required,
        ClaveSatRegimenFiscalEmisor: validation.required,
        ClaveSatUsoReceptor: validation.required,
        ClaveSatMoneda: validation.required,
        TipoCambio: validation.required,
        IdSucursal: validation.required,
        Conceptos: validarConceptos
    };
    return validation.getErrors(rules, x);
}

interface State {
    tasaRetencion?: number | null;
    tasaRetencionInicial: number | null;
    modificarTasaRetencion: boolean;
}

/**
* Componente para editar una factura
*/
class InformacionFacturaNoRx extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            modificarTasaRetencion: false,
            tasaRetencionInicial: (props.value.Conceptos && props.value.Conceptos.length > 0) ? props.value.Conceptos[0].TasaRetencionIva || 0 : 0,
            tasaRetencion: (props.value.Conceptos && props.value.Conceptos.length > 0) ? props.value.Conceptos[0].TasaRetencionIva || 0 : 0,
        };
    }

    value = (props: Props) => props.value;
    tasaRetencion = (state: State) => state.tasaRetencion;
    modificarTasaRetencion = (state: State) => state.modificarTasaRetencion;
    Conceptos = (props: Props) => props.value.Conceptos;
    esPersonaMoral = (props: Props) => props.value.ReceptorFactura.TipoPersona == models.TipoPersona.Moral;
    ocultarMensajeTimbrado = (props: Props) => props.ocultarMensajeTimbrado;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => toObservable(validation.hasError(x)));
    getField = formfields(() => this.props, () => this.errors(this.props));

    Cliente = (props: Props) => props.value.PuedeTenerCalculo6Decimales && props.value;

    modalManager = kea.createModalManager();

    onTimbrar = async () => {
        if (await kea.yesno("¿Timbrar factura?")) {
            const hasError = await nextToPromise(this.hasError(this.props));
            if (!hasError) {
                if (this.props.onGuardarSinSalir)
                    await this.props.onGuardarSinSalir();
                const value = await this.props.value;
                await resources.Factura.TimbrarFactura(value.IdRegistro);
                await kea.message("La factura ha sido timbrada");
                if (this.props.onRefresh)
                    this.props.onRefresh();
            } else {
                await kea.message("Error", "La factura no es valida, revise que todos los campos contengan datos correctos", "error");
            }
        }
    }

    onCancelar = async () => {
        const value = this.props.value;
        await CancelarFactura(value.IdRegistro, this.modalManager.showModal);
    }

    onGenerarNotaDeCredito = async () => {
        const value = this.props.value;
        if (await kea.yesno("¿Generar nota de crédito para esta factura?", "" + value.SerieFolio)) {
            var idRegistro = await resources.Factura.GenerarNotaCredito(value.IdRegistro);
            history.go(`../${idRegistro}`);
        }
    }

    permisoCapturar = (x: Props) => x.permisos.Facturas.VerCrearFacturaArbitraria;
    permisoCancelar = (x: Props) => x.permisos.Facturas.VerBotonCancelarFactura;
    permisoTimbrar = (x: Props) => x.permisos.Facturas.VerBotonTimbrarFactura;
    permisoGenerarNotaCredito = (x: Props) => x.permisos.Facturas.VerGenerarNotaDeCredito;
    esNueva = (x: Props) => x.nuevo;
    idSucursal = (x: Props) => x.value.IdSucursal;
    esManual = (props: Props) => props.value.Origen == models.OrigenFactura.Manual || props.value.Origen == models.OrigenFactura.NotaDeCargo;

    totalFactura = createSelectorRx(this.Conceptos, (conceptos) => {
        return (conceptos != null && conceptos.length > 0) ?
            conceptos.map(x => (Math.round(x.PrecioUnitario * 100) / 100) * Math.round((1 + (x.TasaIva - x.TasaRetencionIva)) * 100) / 100).reduce(function (acc, val) { return acc + val; })
            : 0;
    });

    onCambiarSucursal = async (idSucursal: number | null) => {
        var value = this.props.value;
        var cambio: Partial<Entity> = { IdSucursal: idSucursal!, CodigoPostal: "" };
        if (idSucursal) {
            var sucursal = await resources.Sucursal.getMemo(idSucursal);
            cambio.CodigoPostal = sucursal.CodigoPostal;
        }
        const nuevo = { ...value, ...cambio };
        this.props.onChange(nuevo);
    }

    onContabilizar = async () => {
        await resources.Factura.ContabilizarFactura(this.props.value.IdRegistro);
        await kea.message("Factura contabilizada", "", "success");
    }

    onConvertirAManual = async () => {
        if (await kea.yesno("¿Convertir factura a manual?")) {
            if (this.props.onGuardarSinSalir)
                await this.props.onGuardarSinSalir();
            await resources.Factura.ConvertirFacturaEnManual(this.props.value.IdRegistro);
            await kea.message("Factura convertida a manual", "", "success");
            this.props.onRefresh();
        }
    }

    //Se encarga de recalcular los impuestos de los conceptos de la factura según el tipo de persona de la factura
    onCambiarTipoPersona = async () => {
        const result = await this.modalManager.showModal(TipoPersonaModal, null, { tipo: this.props.value.ReceptorFactura.TipoPersona });
        if (result.result) {
            await resources.Factura.CambiarTipoPersona(this.props.value.IdRegistro, result.value.tipo);
            await kea.message("Cambiar tipo de person", "Se cambio correctamente el tipo de person");
            this.props.onRefresh();
        }
    }

    handleChangeTasaRetencion = async (tasa: number | null) => {
        this.setState({ tasaRetencion: tasa });
        const conceptos = this.Conceptos(this.props);
        const nuevosConceptos = conceptos.map(x => ({ ...x, TasaRetencionIva: tasa }) as models.ConceptoFactura);
        const value = this.props.value;
        const cambio: Partial<Entity> = { Conceptos: nuevosConceptos };
        this.props.onChange({ ...value, ...cambio });
    }

    render() {
        const { value, desdeNota, soloLectura } = this.props;
        
        const esNueva = this.esNueva(this.props);
        const esManual = this.esManual(this.props);
        const conceptosFactura = this.Conceptos(this.props);
        const ocultarMensajeTimbrado = this.ocultarMensajeTimbrado(this.props);
        const puedeCapturar = this.permisoCapturar(this.props);
        const puedeCancelar = this.permisoCancelar(this.props);
        const puedeTimbrar = this.permisoTimbrar(this.props);
        const puedeGenerarNotaCredito = this.permisoGenerarNotaCredito(this.props);
        const esPersonaMoral = this.esPersonaMoral(this.props);
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const DateTime = getField(kea.DateTime);
        const Conceptos = getField(ConceptoFacturaList);
        const TipoFactura = getField(selectores.TipoFactura);
        const Moneda = getField(selectores.ClaveMonedaSat);
        const RegimenFiscal = getField(selectores.ClaveRegimenFiscalSat);
        const UsoCFDI = getField(selectores.ClaveUsoCFDISat);
        const MetodoPago = getField(selectores.ClaveMetodoPagoSat);
        const FormaPago = getField(selectores.ClaveFormaPagoSat);
        const TipoCaptura = getField(selectores.TipoCaptura);
        const Caja = getField(selectores.Caja);
        const Sucursal = getField(selectores.Sucursal);
        const SiNo = getField(selectores.SiNo);
        const status = value.EsCancelada ? "Cancelada" : value.EsTimbrada ? "Timbrada" : esNueva ? "Capturando" : "Capturada";

        const tasaRetencion = this.tasaRetencion(this.state);
        const modificarTasaRetencion = this.modificarTasaRetencion(this.state);

        return (
            <div>
                {value.EsTimbrada && !ocultarMensajeTimbrado &&
                    <div className="alert alert-info">
                        <label>Para descargar vea Timbrado</label>
                        <br />
                        Esta factura esta timbrada, para descargar el XML y PDF viaje a la pestaña de timbrado
                    </div>
                }

                {
                    desdeNota != true &&
                    <kea.Title titulo={"Factura"} onRegresar={() => history.go("/operativa/Facturas")} >
                        <kea.Button onClick={this.onCambiarTipoPersona} children="Cambiar tipo de persona" style="primary" tooltip="Cambia el tipo de persona del receptor recalculando los impuestos correspondientes para conservar el total de la factura" />
                        {
                            !value.EsTimbrada && !value.EsCancelada && !esManual &&
                            <kea.Button style="info" onClick={this.onConvertirAManual} children="Convertir a factura manual" />
                        }
                        {
                            !value.EsCancelada && puedeCancelar && !esNueva &&
                            <kea.Button iconClass={fa("times-circle-o")} tooltip="Cancelar esta factura" children="Cancelar" style="danger" onClick={this.onCancelar} />
                        }
                        {
                            !value.EsTimbrada && !value.EsCancelada && puedeTimbrar && !esNueva &&
                            <kea.Button disabled={(value.EsTimbrada)} iconClass={fa("bell")} tooltip="Timbrar esta factura" children="Timbrar" style="warning" onClick={this.onTimbrar} />
                        }
                        <kea.Button onClick={this.onContabilizar} children="Contabilizar" />
                        {
                            value.EsTimbrada && !value.EsCancelada && !value.PagadaCredito &&
                            <div>
                                {
                                    puedeGenerarNotaCredito &&
                                    <kea.Button iconClass={fa("tag")} tooltip="Generar una nota de crédito a partir de esta factura" children="Nota de crédito" style="success" onClick={this.onGenerarNotaDeCredito} />
                                }
                            </div>
                        }
                    </kea.Title>
                }

                {kea.autogrid(6, [
                    kea.autogrid(4, [
                        <kea.Text value={status} label="Status factura" readonly={true} />,
                        <kea.Text value={esNueva ? "Nueva" : this.props.value.SerieFolio} label="Factura:" readonly={true} />,
                        <kea.Text value={models.OrigenFactura[this.props.value.Origen]} label="Origen de la factura" readonly={true} />,
                        <DateTime field="FechaCreacion" label="Fecha de creación" time readonly />,
                        <DateTime field="FechaFactura" label="Fecha de factura" time readonly={soloLectura} />,
                        <DateTime field="FechaPolizaContable" label="Fecha de póliza contable" time readonly={soloLectura} />,
                        <FormaPago field="IdFormaPagoSAT" label="Forma de pago" readonly={soloLectura} />,
                        <MetodoPago field="IdMetodoPagoSAT" label="Método de pago" readonly={soloLectura} />,
                        <Number field="Saldo" label="Saldo" readonly />,
                        <Sucursal field="IdSucursal" label="Sucursal:" onChange={this.onCambiarSucursal} readonly={soloLectura} />,
                        <Sucursal field="IdSucursalCobranza" label="Sucursal cobranza:" readonly={soloLectura} />,
                        <Text field="CodigoPostal" label="Código postal (Lugar de expedición)" readonly />,
                        <TipoCaptura field="TipoCaptura" label="Tipo de captura:" readonly={true} />,
                        <Text field="NoCuentaOrdenante" label="Número cuenta ordenante:" readonly={soloLectura} />,
                        <Text field="NoCuentaBeneficiaria" label="Número cuenta beneficiaria:" readonly={soloLectura} />,
                        <Moneda field="ClaveSatMoneda" label="Moneda:" readonly={soloLectura} />,
                        <Number field="TipoCambio" label="Tipo de cambio:" readonly={soloLectura} />,
                        <UsoCFDI field="ClaveSatUsoReceptor" label="Uso de CFDI:" readonly={soloLectura} />,
                        <RegimenFiscal field="ClaveSatRegimenFiscalEmisor" label="Régimen fiscal del emisor:" readonly={esManual || soloLectura} />,
                        <Text field="Observaciones" label="Observaciones:" readonly={soloLectura} />,
                        <Check field="EsFacturaLogistica" label="Es Factura Logistica" readonly={soloLectura} />
                    ]),
                    <AuxiliarReceptor {...this.props} soloLectura={soloLectura} />
                ])}

                <kea.Panel title="Transición al nuevo esquema de cobranza">
                    <p>
                        Indica que esta factura fue pagada sin REPs, ya sea de crédito o de contado.
                        Esto implica que a pesar de que no tenga REPs el saldo de la factura va a ser 0, y se
                        va a considerar un abono a la factura igual al total de la misma en la lógica para el calculo del saldo del cliente.

                        Este valor lo tienen las facturas de crédito/contado que fueron pagadas con el antigüo proceso de cobranza pero que no tienen REP.
                    </p>
                    <Check field="PagadaSinRep" label="Pagada sin REP" />

                    <hr />

                    <p>
                        Indica que esta factura esta registrada como PUE, pero que en realidad es de crédito. Pudiendo ser que este o no cobrada por la cobranza anteriior
                        Estas facturas provienen del antiguo proceso de cobranza, y son contabilizadas como un cargo para el crédito del cliente, siempre y cuando no esten canceladas.

                        Todas estas facturas deberán de ser canceladas y refacturadas con el tipo PPD para que se le puedan agregar los REPs correspondientes
                    </p>
                    <Check field="PuePeroCredito" label="PUE pero crédito" />

                    <hr />

                    <p>
                        Indica que esta factura esta registrada como PPD, pero que en realidad es de contado, por lo que no debe de afectar a los cargos de crédito.
                        Estas facturas provienen de las facturas de contado que anteriormente fueron marcadas incorrectamente como PPD.
                    </p>

                    <Check field="PpdPeroContado" label="PPD pero contado" />

                    <kea.Button onClick={this.props.onGuardarBanderasCobranza} style="success" iconClass={fa("save")}>
                        Actualizar banderas de cobranza
                    </kea.Button>
                </kea.Panel>

                <div className="row">
                    <div className="col-md-3">
                        <kea.Number
                            value={tasaRetencion}
                            onChange={this.handleChangeTasaRetencion}
                            readonly={(!modificarTasaRetencion || soloLectura)}
                            label="Tasa de retención de IVA global"
                            format="percentage" />
                    </div>
                    <div className="col-md-3">
                        <kea.Button
                            onClick={() => {
                                var next = !modificarTasaRetencion;
                                this.setState({ modificarTasaRetencion: next });
                                if (!next) {
                                    this.handleChangeTasaRetencion(this.state.tasaRetencionInicial);
                                }
                            }}
                            disabled={soloLectura}
                            children="Modificar tasa de retención de IVA" />
                    </div>
                </div>

                <Conceptos field="Conceptos" readonly={soloLectura} value={conceptosFactura} personaMoral={esPersonaMoral} MasDecimales={value.Calculo6Decimales} />
                {this.modalManager.component}
            </div>);
    }
}

export const InformacionFactura = componentToRx(InformacionFacturaNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/informacionfactura.tsx